import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "./Reveal";
import { pricingFaqs } from "@/lib/finendra-data";

export function PricingFaq() {
  return (
    <div className="mx-auto max-w-5xl">
      <Reveal className="max-w-2xl">
        <h2 className="font-display text-3xl font-bold text-brand-navy sm:text-4xl">
          Pricing questions, answered
        </h2>
        <p className="mt-4 text-lg leading-relaxed text-brand-navy/60">
          What each plan covers, how billing works, and how quickly your accountant can be up and
          running on your books.
        </p>
      </Reveal>

      <div className="mt-12 space-y-12">
        {pricingFaqs.map((group, gi) => (
          <Reveal key={group.title} delay={gi * 0.06}>
            <div className="grid gap-6 md:grid-cols-[220px_1fr] md:gap-10">
              <h3 className="font-display text-lg font-bold text-brand-accent md:pt-4">
                {group.title}
              </h3>
              <Accordion type="single" collapsible className="w-full">
                {group.items.map((item, i) => (
                  <AccordionItem key={item.q} value={`${gi}-${i}`}>
                    <AccordionTrigger className="text-left text-base font-semibold text-brand-navy">
                      {item.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-brand-navy/60">{item.a}</AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
